import * as React from 'react'
import '../css/dataDriven.css'
import {useTranslation} from 'react-i18next'
import {tagger} from '../util/util'
import { locales } from '../util/locales'

interface DataDrivenProps {
    className: string
    full: boolean
}

const DataDriven = (props: DataDrivenProps) => {
    const {t, i18n} = useTranslation('rtb')
    const ja = i18n.language.includes(locales.ja)
    const ru = i18n.language.includes(locales.ru)
    const jaStyle = ja ? {margin: '0 -18px'} : {}
    return (
        <div className={'data-driven-process ' + props.className + (ja ? ' jpDrivenHack' : '') + (ru ? ' ruDrivenHack' : '')}>
            <span>
                <img src="https://static.persona.ly/images/exploration.svg" /><span className="data-driven-numbers"><img src="https://static.persona.ly/images/1.svg" /></span>
                <div className="data-driven-dot"><div /></div>
                <div>
                    <div className="ddt">{t('Exploration')}</div>
                    {/* tagger - hack for <br/> in text */}
                    {props.full && <div className="ddp-rtb-description" style={jaStyle}>{tagger(t('Bidding in impressions b'), '')}</div>}
                </div>
            </span>
            <hr />
            <span>
                <img src="https://static.persona.ly/images/basic-logic-level.svg" /><span className="data-driven-numbers"><img
                    src="https://static.persona.ly/images/2.svg" /></span>
                <div className="data-driven-dot"><div /></div>
                <div>
                    <div className="ddt"><p className={ru ? 'ddt-ru-style' : ''}>{t('Basic logic level')}</p></div>
                    {/* tagger - hack for <br/> in text */}
                    {props.full && <div className="ddp-rtb-description" style={jaStyle}>{tagger(t('A basic targeting a'), '') }</div>}
                </div>
            </span>
            <hr />
            <span>
                <img src="https://static.persona.ly/images/unique-model.svg" /><span className="data-driven-numbers"><img src="https://static.persona.ly/images/3.svg" /></span>
                <div className="data-driven-dot"><div /></div>
                <div>
                    <div className="ddt"><p className={ru ? 'ddt-ru-style' : ''}>{t('Unique model')}</p></div>
                    {/* tagger - hack for <br/> in text */}
                    {props.full && <div className="ddp-rtb-description" style={jaStyle}>{tagger(t('A tailor made t'), '')}</div>}
                </div>
            </span>
            <hr />
            <span>
                <img src="https://static.persona.ly/images/engagement-optimalization.svg" /><span className="data-driven-numbers"><img
                    src="https://static.persona.ly/images/4.svg" /></span>
                <div className="data-driven-dot"><div /></div>
                <div>
                    {/* tagger - hack for <br/> in text */}
                    <div className="ddt"><p className={ru ? 'ddt-ru-style ddt-ru-s-optima' : ''}>{tagger(t('Engagement optimization'), '')}</p></div>
                    {props.full && <div className="ddp-rtb-description">{t('Full-funnel data (f')}</div>}
                </div>
            </span>
            <hr />
            <span>
                <img src="https://static.persona.ly/images/scaling.svg" /><span className="data-driven-numbers"><img src="https://static.persona.ly/images/5.svg" /></span>
                <div className="data-driven-dot"><div><img
                    src={props.full ? 'https://static.persona.ly/images/rtb/fill-1.svg' : 'https://static.persona.ly/images/fill-1.svg'} /></div></div>
                <div>
                    <div className="ddt">{t('Scaling')}</div>
                </div>
            </span>
        </div>
    )
}

export default DataDriven


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/dataDriven.tsx